import {
  FaTwitch,
  FaTiktok,
  FaYoutube,
  FaDiscord,
  FaFacebookF,
  FaShirt,
  FaHelmetSafety,
} from "react-icons/fa6";
import { SiPaypal, SiStripe, SiKofi } from "react-icons/si";

const ICONS = {
  twitch: FaTwitch,
  tiktok: FaTiktok,
  youtube: FaYoutube,
  discord: FaDiscord,
  facebook_page: FaFacebookF,
  facebook_personal: FaFacebookF,
  comik_releaf: FaShirt,
  rugged_roofing: FaHelmetSafety,
  paypal: SiPaypal,
  stripe: SiStripe,
  kofi: SiKofi,
};

export const BrandIcon = ({ name, className }) => {
  const Icon = ICONS[name] || FaTwitch;
  return <Icon className={className} />;
};
